<template>
  <section id="footer" data-speed="4" data-type="background">
    <div class="container">
      <div class="row">
        <clearfix :wide="true" :bootstrap="true"></clearfix>

        <footer-menu></footer-menu>
        <footer-badge></footer-badge>
        <footer-copyleft></footer-copyleft>
        <footer-contact></footer-contact>

        <clearfix :wide="true" :bootstrap="true"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
import Clearfix from '@/components/utils/Clearfix'
import FooterBadge from '@/components/partials/FooterBadge'
import FooterCopyleft from '@/components/partials/FooterCopyleft'
import FooterContact from '@/components/partials/FooterContact'
import FooterMenu from '@/components/partials/FooterMenu'

export default {
  components: {
    Clearfix,
    FooterBadge,
    FooterCopyleft,
    FooterContact,
    FooterMenu
  }
}
</script>

<style>
#footer {
  background: url('../../assets/img/bg/about.png') 50% 0 fixed;
  height: auto;
  margin: 0 auto;
  width: 100%;
  position: relative;
  padding: 100px 0;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// Footer.vue?42fe7c11